import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { SupplierRegionsData } from 'dm-src/models/supplier-regions-data';
import { DeliveryPlanType } from 'dm-src/types/delivery-plan-type';
import { SupplierRegion } from 'dm-src/models/supplier-region';
import { ISelectOption } from 'shared';
import { UnassignedTimeSlotPlan } from 'dm-src/models/unassigned-time-slot-plan';
import { DeliveryPlan } from 'dm-src/models/delivery-plan';

export const SUPPLIER_REGIONS_SERVICE_IMPL = new InjectionToken<ISupplierRegionsService>(
    'supplierRegionsServiceImpl'
);

export interface ISupplierRegionsService {
    getSupplierRegionsData(): Observable<HttpResponse<SupplierRegionsData>>;
    getRegionFilterOptions(): Observable<HttpResponse<ISelectOption[]>>;
    saveSupplierRegionsData(
        supplierRegionsData: SupplierRegion[]
    ): Observable<HttpResponse<SupplierRegion[]>>;
    deleteSupplierRegion(supplierRegionID: string): Observable<HttpResponse<void>>;
    replanRoutes(
      supplierRegionID: string,
      deliveryDate: string,
      deliveryPlanType: DeliveryPlanType,
      useCurrentTime: boolean
    ): Observable<HttpResponse<any>>;
    planUnassignedTimeSlots(
        supplierRegionID: string,
        deliveryDate: string
    ): Observable<HttpResponse<UnassignedTimeSlotPlan>>;
    publishDeliveryPlan(
        supplierRegionID: string,
        deliveryDate: Date
    ): Observable<HttpResponse<void>>;
    getDeliveryPlan(
        supplierRegionID: string,
        deliveryDate: string,
        deliveryPlanType: DeliveryPlanType,
        courierID?: string
    ): Observable<HttpResponse<DeliveryPlan>>;
}
